import React from 'react';
import PropTypes from 'prop-types';
import { GridColumnMenuWrapper } from '@progress/kendo-react-grid';
import AiPlusIcon from './AiPlusIcon';

// Custom header cell for the Unresolved Issues column.
// In Kendo Grid v6, headerCell renders the *inner* content — Kendo wraps it in <th>
// and <span class="k-cell-inner">. We render the k-link (sort trigger) and the
// column menu button via GridColumnMenuWrapper (mirroring GridHeaderCell's render).
function IimHeaderCell({ title, onClick, columnMenuWrapperProps }) {
  return (
    <>
      <a className="k-link" onClick={onClick} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <AiPlusIcon />
        <span className="k-column-title">{title}</span>
      </a>
      {/* eslint-disable-next-line react/jsx-props-no-spreading -- Kendo requires forwarding the full prop bag to GridColumnMenuWrapper */}
      {columnMenuWrapperProps?.columnMenu && <GridColumnMenuWrapper {...columnMenuWrapperProps} />}
    </>
  );
}

IimHeaderCell.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  columnMenuWrapperProps: PropTypes.object
};

export default IimHeaderCell;
